import { put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import sign from './sign';
import { nameBySave } from '../../../utils/utils';
import { OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import { uploadFile, uploadSignFile } from '../actions';
import { dateFormatter } from '../../../utils/formatters';

export default function* loadSignUploadDocument(document, cert, detached = true, loadUrl = '', uploadUrl = '', action) {
  const pool = {
    signature_signer: cert.cn,
    signature_cast: cert.thumbprint,
    certificate_start_date: cert.certFromDate.toISOString(true),
    certificate_end_date: cert.certToDate.toISOString(true),
  };

  const url = loadUrl || `${BACKEND_URL}/resources/documents/${document.id}/generate-signed-pdf`;
  const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
  if (dataResponse.status !== OK) {
    let error;
    try {
      error = yield dataResponse.json();
    } catch (e) {
      // Ошибка не в JSON-формате.
    }
    throw new Error(error?.message || 'Ошибка: не найден файл для подписи');
  }
  const data = yield dataResponse.blob();
  if (!data) {
    throw new Error('Ошибка: не найден файл для подписи');
  }
  const signature = yield sign(cert, data, detached);
  if (typeof signature === 'string') {
    throw new Error(signature);
  }
  const fileFormData = new FormData();
  const templateName = document && document.notification_template && document.notification_template.name
    ? document.notification_template.name
    : document.id;
  const name = nameBySave(`${templateName} № ${document.number} от ${dateFormatter(document.created_at)}.pdf`);

  fileFormData.append('model_type', 'document');
  fileFormData.append('model_id', document.id);
  fileFormData.append('collection_name', 'signed');
  fileFormData.append('name', name);
  fileFormData.append('file', data, nameBySave(name));
  fileFormData.append('sign_file', signature, nameBySave(`${name}.sig`));
  const fileUploadPromise = yield put(uploadSignFile(fileFormData));
  const fileUpload = yield fileUploadPromise;
  //
  // const signatureUploadPromise = yield put(uploadFile(sigFormData));
  // const signatureUpload = yield signatureUploadPromise;
  if (!fileUpload) {
    throw new Error(`Фаил «${name}.sig» не сохранен`);
  }
  return signature;
}
